export const docOptions = [
  { value: "highSchool", label: "High School" },
  { value: "diploma", label: "Diploma" },
  { value: "bachelorDegree", label: "Bachelor's Degree" },
  { value: "mastersDegree", label: "Master's Degree" },
  { value: "phd", label: "PHD" },
    { value: "constructionDocs", label: "Done Construction" },
    { value: "workPerformanceDoc", label: "Work Performed" },
    { value: "experienceDoc", label: "Experience" },
    { value: "itReturns", label: "IT Returns for Last Three years" },
    { value: "declaration", label: "Applicant Declaration" },
    { value: "otherDoc", label: "Additional other Document" }
   
  ];

  export const fieldsOptions =  [
    { value: "applicantName", label: "Applicant Name" },
    { value: "perAddress", label: "Permanent Address" },
    { value: "regOffAddress", label: "Registered Office Address" },
    // { value: "regEmailId", label: "Registered Email ID" },
    // { value: "mobileNo", label: "Mobile Number" },
    { value: "dob", label: "DOB" },
    { value: "yrOfExpAsBusErr", label: "Year of Experience as Business Engineer" },
    // { value: "itReturnDetail", label: "IT Returns for Last Three years" },
    // { value: "declarationDetail", label: "Applicant Declaration" },

    { value: "highSchool", label: "High School" },
    { value: "diploma", label: "Diploma" },
    { value: "bachelorDegree", label: "Bachelor's Degree" },
    { value: "mastersDegree", label: "Master's Degree" },
    { value: "phd", label: "PHD" },
    { value:"itReturns_1",label:"IT Returns 1"},
    { value:"itReturns_2",label:"IT Returns 2"},
    { value:"itReturns_3",label:"IT Returns 3"},
    { value: "experienceDoc_1", label: "Experience Detail One" },
    { value: "experienceDoc_2", label: "Experience Detail Two" },
    { value: "experienceDoc_3", label: "Experience Detail Three" },
    { value: "workPerformanceDoc_1", label: "Work Performed Detail One" },
    { value: "workPerformanceDoc_2", label: "Work Performed Detail Two" },
    { value: "workPerformanceDoc_3", label: "Work Performed Detail Three" },
    { value: "constructionDocs_1", label: "Construction Done Details One" },
    { value: "constructionDocs_2", label: "Construction Done Details Two" },
    { value: "constructionDocs_3", label: "Construction Done Details Three" },
    { value: "structureErrDoc", label: "Structural Engineering" },
        { value: "otherDoc", label: "Additional other Document" }


  ];